import { useTranslation } from 'react-i18next';
import LinkIcon from '@/assets/icons/in-app-link.svg?react';
import { Button, Text } from '@/components/base';
import { CopyLinkStatus } from '@/components/InAppBrowserNotice/components/CopyLinkStatus';

interface CopyLinkFieldProps {
  link: string;
  isLinkCopied: boolean;
  onCopyLink: () => void;
}

// The whole field copies; it shows the link without its scheme, as a browser's address bar does.
export const CopyLinkField = ({ link, isLinkCopied, onCopyLink }: CopyLinkFieldProps) => {
  const { t } = useTranslation('activitySession');

  return (
    <Button
      variant="unstyled"
      onClick={onCopyLink}
      aria-label={t('in_app_browser_notice.copy_link')}
      className="flex w-full items-center gap-1.5 rounded-xl border border-revamp-gray-200 px-3 py-2.5 text-left"
    >
      <LinkIcon aria-hidden className="size-[22px] shrink-0" />
      <Text version="revamp-v1" variant="body5" className="min-w-0 flex-1 truncate font-semibold text-revamp-gray-900">
        {link.replace(/^https?:\/\//, '')}
      </Text>
      <CopyLinkStatus isLinkCopied={isLinkCopied} />
    </Button>
  );
};
